import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取供应商统计信息
 * @param current
 * @param size
 */
export const getSupplierStatis = (params) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/pageFinaceByMechant',
    method: 'post',
    data: params
  })
}

/**
 * 获取司机统计
 * @param current
 * @param size
 */
export const getDriverStatis = (params) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/pageFinanceByDriver',
    method: 'post',
    data: params
  })
}

/**
 * 获取车辆统计
 * @param current
 * @param size
 */
export const getCarStatis = (params) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/pageFinanceByCar',
    method: 'post',
    data: params
  })
}

/**
 * 获取明细统计
 * @param params
 */
export const getDetailsStatis = (params) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/pageOrderForFinanceByParam',
    method: 'post',
    data: params
  })
}

/**
 * 导出明细
 * @param params
 */
export const exportDetails = (params) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/exportOrderInfo',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 * 导出明细汇总
 * @param params
 */
export const exportAllDetails = (params) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/exportFinanceTotal',
    method: 'get',
    params: {
      ...params
    }
  })
}
